import React, { useState, useRef, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import "../styles/login.css";
import { useHistory } from "react-router-dom";
import { Notification, TopNotification } from "./Notification";

function Register() {
  const { register, currentUser, setGlobalNot } = useAuth();
  const [loading, setLoading] = useState(false);
  const usernameRef = useRef();
  const emailRef = useRef();
  const passwordRef = useRef();
  const passwordConfirmRef = useRef();
  const history = useHistory();
  const [error, setError] = useState();
  const [usernameError, setUsernameError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [emailError, setEmailError] = useState("");
  const back = useState("< GERI");

  useEffect(() => {
    if (currentUser) {
      history.push("/account");
    }
  }, [currentUser]);

  const handleBack = (e) => {
    e.preventDefault();
    history.push("/account");
  };

  function signUp(e) {
    e.preventDefault();

    //kullanıcı bilgileri kısıtlamaları kontrolü

    const validationResult = formValidation(
      usernameRef.current.value,
      emailRef.current.value,
      passwordRef.current.value,
      passwordConfirmRef.current.value
    );

    if (!validationResult) {
      return;
    }

    try {
      setLoading(true);
      register(
        usernameRef.current.value,
        emailRef.current.value,
        passwordRef.current.value
      ).then((response) => {
        const data = response.data;
        if (`${data}` === "kullanıcı adı kullanılıyor") {
          setError(data);
        } else if (`${data}` === "geçersiz link") {
          setError(data);
        } else if (`${data}` === "e-posta adresi kullanılıyor") {
          setError(data);
        } else {
          console.log("kullanıcı oluşturuldu");
          setGlobalNot("Lütfen e-postanızı kontrol edin.");
          history.push("/login");
        }
        setLoading(false);
        clearInput();
      });
    } catch {
      console.log("error");
      setError("HATA: lütfen daha sonra tekrar deneyiniz.");
      setLoading(false);
      clearInput();
    } finally {
      setLoading(false);
    }
  }

  const clearInput = () => {
    usernameRef.current.value = "";
    emailRef.current.value = "";
    passwordRef.current.value = "";
    passwordConfirmRef.current.value = "";
    setUsernameError("");
    setEmailError("");
    setPasswordError("");
  };

  const formValidation = (username, email, password, passwordConfirm) => {
    var letters = /^[A-Za-z]+$/;
    var passw = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,20}$/;
    var mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

    if (!username.match(letters)) {
      setUsernameError("kullanıcı adı sadece harflerden oluşmalı");
      return false;
    }
    if (username.length > 10 || username.length < 3) {
      setUsernameError("kullanıcı adı 3-10 karakter uzunluğunda olmalı");
      console.log(username.length);
      return false;
    }
    if (!password.match(passw)) {
      setPasswordError(
        "Şifreniz rakam, büyük harf ve küçük harf içeren 6-20 karakter uzunluğunda oluşmalı"
      );
      return false;
    }
    if (!email.match(mailformat)) {
      setEmailError("Geçersiz e-posta");
      return false;
    }
    if (password !== passwordConfirm) {
      setPasswordError("Hatalı şifre tekrarı");
      return false;
    }
    return true;
  };

  return (
    <div className="login">
      <div className="register__container">
        <form onSubmit={signUp} className="login__form">
          <h1>KAYIT OL</h1>
          {error && <TopNotification notification={error} color={"red"} />}
          <div className="h5">
            <h5>KULLANICI ADI</h5>
          </div>
          <div className="input">
            <input type="text" ref={usernameRef} required />
          </div>

          {usernameError && <Notification notification={usernameError} />}
          <div className="h5">
            <h5>E-POSTA</h5>
          </div>
          <div className="input">
            <input type="email" ref={emailRef} required />
          </div>

          {emailError && <Notification notification={emailError} />}
          <div className="h5">
            <h5>SIFRE</h5>
          </div>
          <div className="input">
            <input type="password" ref={passwordRef} required />
          </div>

          {passwordError && <Notification notification={passwordError} />}
          <div className="h5">
            <h5>SIFRE TEKRARI</h5>
          </div>
          <div className="input">
            <input type="password" ref={passwordConfirmRef} required />
          </div>
          <div className="register__buttons">
            <div className="button buttonLeft">
              <button onClick={handleBack} className="login__signInButton">
                {back}
              </button>
            </div>
            <div className="button buttonRight">
              <button
                disabled={loading}
                type="submit"
                className="login__signInButton"
              >
                KAYIT OL
              </button>
            </div>
          </div>

          <div className="topLeftBorder">
            <div>
              <div className="borderTop"></div>
              <div className="borderLeft"></div>
            </div>
          </div>
          <div className="bottomRigtBorder">
            <div>
              <div className="borderRight"></div>
              <div className="borderBottom"></div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Register;
